import React from 'react';
import { Box, Link, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import dayjs from 'dayjs';

import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { ReactComponent as LaunchIcon } from 'assets/images/launch-24px.svg';

import { Colors } from 'typings';
import { formatDate } from 'utils/functions';

interface Props {
  lead: {
    channelWebsite?: string | null;
    createdAt?: string | Date;
    emailContentLink?: string | null;
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  innerWrapper: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
  },
  statusText: {
    padding: theme.spacing(0, 1),
    fontWeight: 500,
    borderBottom: `2px solid ${theme.palette.text.primary}`,
  },
  caption: {
    fontWeight: 500,
    padding: theme.spacing(0, 1),
    color: theme.palette.grey['500'],
  },
  link: {
    fontSize: theme.spacing(1.5),
    padding: theme.spacing(0, 1),
    '& a': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  svg: {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
    padding: theme.spacing(0.25),
    borderRadius: '50%',
    boxShadow: `0 0 2px ${Colors.LIGHT_GRAY}`,
  },
  emailSvg: {
    width: theme.spacing(1.5),
    fill: theme.palette.secondary.main,
  },
}));

const LeadCreation = ({ lead }: Props) => {
  const classes = useStyles({ lead });
  const relativeDate = dayjs.utc(lead.createdAt).fromNow() || '';
  const formattedDate = formatDate(`${lead.createdAt}`, 'MMMM D, YYYY h:mm:ss A');
  const message = `Lead created ${relativeDate} via ${lead.channelWebsite}`;

  return (
    <Box className={classes.container}>
      <Box className={classes.innerWrapper}>
        <PersonAddIcon className={classes.svg} />
        <Box>
          <Typography variant="body2" className={classes.statusText}>
            {message}
          </Typography>
          <Typography variant="caption" className={classes.caption}>
            {formattedDate}
          </Typography>
        </Box>
        <PersonAddIcon className={classes.svg} />
      </Box>
      {!!lead.emailContentLink && (
        <Typography className={classes.link}>
          <Link href={lead.emailContentLink} target="_blank" rel="noopener noreferrer">
            view email <LaunchIcon className={classes.emailSvg} />
          </Link>
        </Typography>
      )}
    </Box>
  );
};

export default LeadCreation;
